// Libraries
import styled from "styled-components"


export const VenturesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const VenturesListContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  
`

